import React, { FC, useState } from "react";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import TableTab from "../../../tabs/table-tab";
import { DEF_PG_SIZE_WIZARD } from "../../../../constants/maximum-page-size";
import { useFormikContext } from "formik";
import { getEventTypes } from "../../../../services/eventTypeService";
import EventTypeSearch from "../../../../models/search/EventTypeSearch";
import EventTypeColumns from "../../../../models/ColumnDefinitions/EventTypeColumns";
import { toast } from "react-toastify";
import { MAX_RECORDS } from "../../../../constants/notification-key";
import { WizardStepLayout } from "../../../../components/wizard/wizard-summary-layout";

interface Props {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription: (discription: string) => void;
}

const EventSelectionStep: FC<Props> = ({onBack, onNext, setSideBarStepDescription}) => {
    const { translate } = useLocale(); 
    const { setFieldValue, values } = useFormikContext<any>();
    const [selectedIds, setSelectedIds] = useState<string[]>(values.eventSelectionId || []);

    const onLocalNext = (event: any) => {
        if (selectedIds.length > 0) {
            onNext({ ...event});
            setFieldValue("eventSelectionId", selectedIds);
            setSideBarStepDescription(`${selectedIds.length} ${translate.byKey(TranslationKeys.selected)}`)
        }
    }

    const itemSelected = (selectedItem: any) => {
        if (selectedItem) {
            setFieldValue("eventSelectionId", selectedIds);
        }
    }

    const validateSelectedIds = (ids: string[]) => {
        if (ids.length >= MAX_RECORDS) {
            toast.error(translate.byKey(TranslationKeys.aMaximimumOf20RecordsCanBeSelected));
            setSelectedIds([...selectedIds])
        } else {
            setSelectedIds([...ids])
        }
    }

    return (
        <WizardStepLayout onBack={onBack} onNext={onLocalNext} nextDisabled={selectedIds.length === 0}>
            <div className="pl-3">
                <TableContextProvider
                    usePagination
                    useTable
                    useFilter
                    useSearch
                    dataMethod={(listParameters) => getEventTypes(translate, listParameters)}
                    tableDescriptor={EventTypeColumns}
                    searchDescriptor={EventTypeSearch}
                    maxPageSize={DEF_PG_SIZE_WIZARD}
                    canExportReport={false}>
                    <TableTab
                        title={translate.byKey(TranslationKeys.selectTheEvent)}
                        onRowClicked={itemSelected}
                        tableId={'eventSelectionTable'}
                        selectedIds={selectedIds}
                        setSelectedIds={validateSelectedIds}
                        style={{ maxHeight: "calc(100% - 70px)" }}
                        cyName="eventSelectionStep"
                    />
                </TableContextProvider>
            </div>
        </WizardStepLayout>
    )
}

export default EventSelectionStep;
